import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-860b4ed2")

_pushScopeId("data-v-860b4ed2")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "dt-mask-box" }, null, -1)
const _hoisted_3 = { class: "dt-update-box" }
const _hoisted_4 = { class: "dt-update-header-right click-element" }
const _hoisted_5 = { class: "dt-update-content" }
const _hoisted_6 = { class: "dt-update-title" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_ctx.updateStatus)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("i", {
              class: "dt-update-close-icon",
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.updateStatus = 0))
            })
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("p", _hoisted_6, _toDisplayString(_ctx.updateContent.content), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})